/*
 *  Dynamic imports of js2 code. One use case is for rendering React components while passing (initial) component data from django templates.
 *  This approach is a step in between migration of frontend from jquery/kendo/django templates to React/rest APIs and should be phased
 *  out when and where possible/convenient.
 */

const showMultiSelect = (elementId, options, defaultValues) => {
  import(
    "./multi-select"
    /* webpackChunkName: 'multiSelectDropdown' */
  ).then(({ default: renderMultiSelect }) => {
    renderMultiSelect(elementId, options, defaultValues);
  });
};

const showMaxFileSizeModal = () => {
  import(
    "./max-file-size-dialog"
    /* webpackChunkName: 'maxFileSizeModal' */
  ).then(({ default: renderMaxFileSizeModal }) => {
    renderMaxFileSizeModal();
  });
};

const showReleaseNotes = () => {
  import("./release-notes-modal").then(
    ({ default: renderReleaseNotesModal }) => {
      renderReleaseNotesModal();
    }
  );
};

const showPreviewVisualizationModal = data => {
  import("./preview-visualization-modal").then(
    ({ default: renderPreviewVisualizationModal }) => {
      renderPreviewVisualizationModal(data);
    }
  );
};

const showYesNoModal = ({ ...props }) => {
  import("./render-connectapp-modal").then(
    ({ default: renderConnectAppModal }) => {
      renderConnectAppModal({ ...props });
    }
  );
};

export {
  showMultiSelect,
  showMaxFileSizeModal,
  showReleaseNotes,
  showPreviewVisualizationModal,
  showYesNoModal
};
